// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ElementType,
} from "./types";

export default {
  presenceId: __t.u64(),
  sessionId: __t.option(__t.u64()),
  get elementType() {
    return ElementType;
  },
  elementId: __t.string(),
  message: __t.string(),
  priority: __t.u8(),
  durationMs: __t.option(__t.u32()),
};
